import {
  formatBytesString,
  getSignedUrlForHostedFileUrl,
  IconButton,
  Icons,
  LoadingIndicator,
} from '@commenda/kakashi';
import { downloadFileFromLink, getFileIcon } from '@commenda/utils';
import { ChatProps } from '../../ChatRoom/types';

const ChatFileCard = ({
  fileName,
  fileSize,
  isUploading,
  onFileRemove,
  onFileDownload,
  fileUrl,
  fileId,
  corporationId,
}: {
  fileName: string;
  fileSize?: number;
  fileUrl?: string;
  isUploading?: boolean;
  onFileRemove?: () => unknown;
  onFileDownload?: ChatProps['onFileDownload'];
  fileId?: number;
  corporationId?: number;
}) => {
  const FileIconComponent: React.ElementType = getFileIcon(fileName || '');

  return (
    <div className="bg-bg-primary border border-border-secondary flex items-center gap-lg h-[76px] overflow-hidden p-xl rounded-xl w-full">
      {/* File icon */}
      <div className="shrink-0 size-10">
        <FileIconComponent className="size-10" />
      </div>

      {/* File info */}
      <div className="flex flex-col gap-xs flex-1 min-w-0 justify-center">
        <span className="font-mulish text-sm font-medium leading-5 text-text-secondary truncate">
          {fileName}
        </span>
        {fileSize ? (
          <span className="font-mulish text-sm font-normal leading-5 text-text-tertiary">
            {formatBytesString(fileSize)}
          </span>
        ) : null}
      </div>

      {/* Action button */}
      {isUploading ? (
        <LoadingIndicator size={16} />
      ) : fileUrl && fileName ? (
        <IconButton
          variant="default"
          size="md"
          icon={<Icons.Download01 className="size-5" />}
          onClick={async () => {
            if (corporationId && fileUrl) {
              const res = await getSignedUrlForHostedFileUrl(
                fileUrl,
                corporationId
              );
              downloadFileFromLink(res, fileName);
            } else {
              const res = await onFileDownload(fileId);
              downloadFileFromLink(res.signedUrl, fileName);
            }
          }}
          aria-label="Download file"
        />
      ) : fileId && onFileDownload ? (
        <IconButton
          variant="default"
          size="md"
          icon={<Icons.Download01 className="size-5" />}
          onClick={async () => {
            const res = await onFileDownload(fileId);
            downloadFileFromLink(res.signedUrl, fileName);
          }}
          aria-label="Download file"
        />
      ) : (
        onFileRemove && (
          <IconButton
            variant="destructive"
            size="md"
            icon={<Icons.Trash01 className="size-5" />}
            onClick={onFileRemove}
            aria-label="Remove file"
          />
        )
      )}
    </div>
  );
};

export default ChatFileCard;
